// ! Note !
// This is a duplicate on web_presenter config_app_util.js. If you change
// something here, should should most likely change it there.
import { env } from '@polleverywhere/core'

const SINGULARITY_URLS = {
  name: 'singularity',
  presenter_url: env.get('singularity_url') ? env.get('singularity_url').toString() : 'https://beta.polleverywhere.com'
}

export const appConfig = () => {
  return SINGULARITY_URLS
}
